module.exports = __webpack_public_path__ + "static/media/BannerD12.0eaed6b0.png";